module.exports = __webpack_public_path__ + "static/img/syxtb.204fd506.png";